import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

// import Table from "../../../../core/common/dataTable/index";
import { useSelector } from "react-redux";
import PannelApplication from ".";
import FormApplication from ".";

const ApmcFormApplication = () => {
   const language = useSelector((state:any)=>state.auth.language);
    const userDetails = useSelector((state:any)=>state.auth.userDetails)
    const roleIdentifier = useSelector((state: any) => state.auth.userDetails?.Role?.Role_Identifier);
    
    // const status = "pa" 
    //.log('userrr', userDetails)
      

    return (
        <>
            {/* Page Wrapper */}
            <div className="page-wrapper">
                <div className="content">
                    {/* Breadcrumb */}
                    <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
                        <div className="my-auto mb-2">
                            <h2 className="mb-1">{language.application_list}</h2>
                        </div>
                    </div>
          
                    <div className="card">
                     

                        <div className="card-body p-0">
                            <FormApplication status="all" />
                        </div>
                    </div>
                
                </div>
            </div>
        </>
    );
};

export default ApmcFormApplication;
